import FiveStarHotel from "@website/ui/stars-hotel-image/assets/five-star-hotel.png";
import FourStarHotel from "@website/ui/stars-hotel-image/assets/four-star-hotel.png";
import ThreeStarHotel from "@website/ui/stars-hotel-image/assets/three-star-hotel.png";
import TwoStarHotel from "@website/ui/stars-hotel-image/assets/two-star-hotel.png";

export const starsHotelImage = (stars: number): { src: string } => {
  if (stars === 3) return ThreeStarHotel;
  if (stars === 4) return FourStarHotel;
  if (stars === 5) return FiveStarHotel;
  return TwoStarHotel;
};
